import { Card, Col, Pagination, Row, Tag } from 'antd'
import dayjs from 'dayjs'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import pushApi from '../../api/push.api'
import ContentHeader from '../../components/shared/ContentHeader'
import styles from '../../styles/customer.module.scss'

const KakaoHistoryDetailPage = () => {
  const { campaignId } = useParams()
  const navigate = useNavigate()
  const [detailData, setDetailData] = useState({
    content: [],
    pageable: { pageNumber: 0, pageSize: 10 },
    totalElements: 0,
  })
  const [isLoading, setIsLoading] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)

  const getDetailData = async (page = 0) => {
    try {
      setIsLoading(true)

      const res = await pushApi.getPushHistoryDetail(campaignId, {
        page: page,
        size: 10,
      })
      console.log('getDetailData res:', res.data)
      setDetailData({
        content: res.data.content,
        pageable: res.data.pageable,
        totalElements: res.data.totalElements,
      })
    } catch (error) {
      console.log('getDetailData error:', error.response?.data || error)
    } finally {
      setIsLoading(false)
    }
  }

  const handlePageChange = (page) => {
    setCurrentPage(page)
    getDetailData(page - 1) // API는 0-based, Pagination은 1-based
  }

  const getStatusColor = (status) => {
    switch (status) {
      case 'SUCCESS':
        return 'success'
      case 'FAIL':
        return 'error'
      case 'RESERVED':
        return 'warning'
      default:
        return 'default'
    }
  }

  const getStatusText = (status) => {
    switch (status) {
      case 'SUCCESS':
        return '성공'
      case 'FAIL':
        return '실패'
      case 'RESERVED':
        return '예약중'
      default:
        return status
    }
  }

  const getStatusStyle = (status) => {
    if (status === 'FAILED') {
      return {
        backgroundColor: '#EB516F',
        color: 'white',
        border: 'none',
      }
    }
    return {}
  }

  useEffect(() => {
    if (campaignId) {
      getDetailData()
    }
  }, [campaignId])

  if (isLoading) {
    return (
      <div style={{ textAlign: 'center', padding: '50px' }}>로딩 중...</div>
    )
  }

  return (
    <>
      <ContentHeader title="카카오 알림톡 상세 내역" />
      <div
        className={`${styles['product-register-wrap']}`}
        style={{ minWidth: '1024px' }}
      >
        <div
          className={`${styles['product-register-border-box']}`}
          style={{
            padding: '20px 25px 40px 25px',
            height: 'fit-content',
            marginTop: '20px',
          }}
        >
          {/* 캠페인 정보 요약 */}
          <Card
            style={{
              borderRadius: '12px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              border: '1px solid #f0f0f0',
              marginBottom: '20px',
            }}
          >
            <Row gutter={[24, 16]}>
              <Col span={8}>
                <div style={{ marginBottom: '8px' }}>
                  <span style={{ fontWeight: 'bold', color: '#8c8c8c' }}>
                    캠페인 ID:
                  </span>{' '}
                  <Tag color="default" style={{ marginLeft: '8px' }}>
                    {campaignId}
                  </Tag>
                </div>
              </Col>
              <Col span={8}>
                <div style={{ marginBottom: '8px' }}>
                  <span style={{ fontWeight: 'bold', color: '#8c8c8c' }}>
                    총 발송 건수:
                  </span>{' '}
                  <span style={{ color: '#262626', fontWeight: 'bold' }}>
                    {detailData.totalElements.toLocaleString()}건
                  </span>
                </div>
              </Col>
              <Col span={8}>
                <div style={{ marginBottom: '8px' }}>
                  <span style={{ fontWeight: 'bold', color: '#8c8c8c' }}>
                    현재 페이지:
                  </span>{' '}
                  <span style={{ color: '#262626' }}>
                    {currentPage} / {Math.ceil(detailData.totalElements / 10)}
                  </span>
                </div>
              </Col>
            </Row>
          </Card>

          {/* 메시지 목록 */}
          <div style={{ marginBottom: '20px' }}>
            <h3 style={{ marginBottom: '16px', color: '#262626' }}>
              발송 메시지 목록
            </h3>

            {detailData.content.map((item) => (
              <Card
                key={item.id}
                style={{
                  borderRadius: '8px',
                  boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
                  border: '1px solid #f0f0f0',
                  marginBottom: '12px',
                }}
              >
                <Row gutter={[16, 0]} align="middle">
                  <Col span={4}>
                    <div style={{ textAlign: 'center' }}>
                      <Tag
                        color={getStatusColor(item.status)}
                        style={getStatusStyle(item.status)}
                      >
                        {getStatusText(item.status)}
                      </Tag>
                    </div>
                  </Col>
                  <Col span={4}>
                    <div style={{ textAlign: 'center' }}>
                      <span style={{ fontSize: '12px', color: '#8c8c8c' }}>
                        사용자 ID
                      </span>
                      <div style={{ fontWeight: 'bold', color: '#262626' }}>
                        {item.userId}
                      </div>
                    </div>
                  </Col>
                  <Col span={4}>
                    <div style={{ textAlign: 'center' }}>
                      <span style={{ fontSize: '12px', color: '#8c8c8c' }}>
                        발송 예약 시간
                      </span>
                      <div style={{ fontSize: '12px', color: '#262626' }}>
                        {item.scheduledAt
                          ? dayjs(item.scheduledAt).format('MM.DD HH:mm')
                          : '-'}
                      </div>
                    </div>
                  </Col>
                  <Col span={4}>
                    <div style={{ textAlign: 'center' }}>
                      <span style={{ fontSize: '12px', color: '#8c8c8c' }}>
                        발송 시간
                      </span>
                      <div style={{ fontSize: '12px', color: '#262626' }}>
                        {item.sentAt
                          ? dayjs(item.sentAt).format('MM.DD HH:mm')
                          : '-'}
                      </div>
                    </div>
                  </Col>
                  <Col span={4}>
                    <div style={{ textAlign: 'center' }}>
                      <span style={{ fontSize: '12px', color: '#8c8c8c' }}>
                        전환 여부
                      </span>
                      <div>
                        <Tag color={item.isRead ? 'success' : 'default'}>
                          {item.isRead ? '페이지 전환' : '페이지 미전환'}
                        </Tag>
                      </div>
                    </div>
                  </Col>
                  <Col span={4}>
                    <div style={{ textAlign: 'center' }}>
                      <span style={{ fontSize: '12px', color: '#8c8c8c' }}>
                        전환 시간
                      </span>
                      <div style={{ fontSize: '12px', color: '#262626' }}>
                        {item.readAt
                          ? dayjs(item.readAt).format('MM.DD HH:mm')
                          : '-'}
                      </div>
                    </div>
                  </Col>
                </Row>

                {/* 실패 사유 표시 */}
                {item.status === 'FAIL' && item.sendFailReason && (
                  <div
                    style={{
                      marginTop: '12px',
                      paddingTop: '12px',
                      borderTop: '1px solid #f0f0f0',
                    }}
                  >
                    <div
                      style={{
                        fontSize: '12px',
                        color: '#8c8c8c',
                        marginBottom: '4px',
                      }}
                    >
                      실패 사유:
                    </div>
                    <div
                      style={{
                        fontSize: '13px',
                        color: '#EB516F',
                        fontWeight: 'bold',
                        backgroundColor: '#fff5f5',
                        padding: '8px 12px',
                        borderRadius: '4px',
                        border: '1px solid #ffebee',
                      }}
                    >
                      {item.sendFailReason}
                    </div>
                  </div>
                )}
              </Card>
            ))}
          </div>

          {/* 페이지네이션 */}
          <div
            style={{
              marginTop: '20px',
              textAlign: 'right',
              display: 'flex',
              justifyContent: 'flex-end',
            }}
          >
            <Pagination
              current={currentPage}
              total={detailData.totalElements}
              pageSize={10}
              onChange={handlePageChange}
              showSizeChanger={false}
              showQuickJumper
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default KakaoHistoryDetailPage
